import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

// Suppress "Encountered two children with the same key" warning
const originalConsoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('Encountered two children with the same key')) {
    return;
  }
  originalConsoleError(...args);
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
